import angular from 'angular';
import commissionLanding from './commissionLanding';
import scenes from './scenes';

export default angular
  .module('commission.scenes.commissionManagement.scenes.commissionLanding', [
    scenes,
  ])
  .component('commissionLanding', commissionLanding).name;
